<script setup lang="ts">
import { useRouter } from 'vue-router'
import homeBackground from '../assets/design/backgrounds/home-background.png'
import { useExperienceStore } from '../stores/experience'

const router = useRouter()
const experienceStore = useExperienceStore()

async function startExperience() {
  await experienceStore.startSession()

  if (experienceStore.questionnaire) {
    await router.push({ name: 'experience' })
  }
}

function openMap() {
  void router.push({ name: 'map' })
}
</script>

<template>
  <div class="view home-view" :style="{ backgroundImage: `url(${homeBackground})` }">
    <p v-if="experienceStore.errorMessage" class="home-error" role="alert">
      {{ experienceStore.errorMessage }}
    </p>

    <div class="home-actions">
      <button
        class="home-start-button"
        type="button"
        :disabled="experienceStore.loading"
        @click="startExperience"
      >
        {{ experienceStore.loading ? '正在准备…' : '点击屏幕开始体验' }}
        <span aria-hidden="true">→</span>
      </button>
      <button class="home-map-button" type="button" @click="openMap">
        跳过体验，直达味觉地图
      </button>
    </div>
  </div>
</template>

